"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _require = require("../../utils"),
    mixin = _require.mixin;

var NavigatorIDImpl = require("./NavigatorID-impl").implementation;

var NavigatorLanguageImpl = require("./NavigatorLanguage-impl").implementation;

var NavigatorOnLineImpl = require("./NavigatorOnLine-impl").implementation;

var NavigatorCookiesImpl = require("./NavigatorCookies-impl").implementation;

var NavigatorPluginsImpl = require("./NavigatorPlugins-impl").implementation;

var NavigatorConcurrentHardwareImpl = require("./NavigatorConcurrentHardware-impl").implementation;

var NavigatorImpl = function NavigatorImpl(args, privateData) {
  _classCallCheck(this, NavigatorImpl);

  this.userAgent = privateData.userAgent;
  this.languages = Object.freeze(["en-US", "en"]);
};

mixin(NavigatorImpl.prototype, NavigatorIDImpl.prototype);
mixin(NavigatorImpl.prototype, NavigatorLanguageImpl.prototype);
mixin(NavigatorImpl.prototype, NavigatorOnLineImpl.prototype);
mixin(NavigatorImpl.prototype, NavigatorCookiesImpl.prototype);
mixin(NavigatorImpl.prototype, NavigatorPluginsImpl.prototype);
mixin(NavigatorImpl.prototype, NavigatorConcurrentHardwareImpl.prototype);
exports.implementation = NavigatorImpl;